import { ReactNode } from 'react';
import styled from 'styled-components';
import { TextCSS } from './Text';

const H1 = styled.h1`
  ${TextCSS({ size: 'XL' })}
  padding: 0 ${(props) => `4${props.theme.unit}`};
  margin-top: 0;
  margin-bottom: 3vmin;
  white-space: pre-line;
  line-height: 1;
  text-align: center;
`;

export const PageTitle = ({ children }: { children: ReactNode }) => {
  return <H1>{children}</H1>;
};
